export const SORT_BY_OPTIONS = [
    {
        key: 1,
        value: 'default',
        label: 'playtech.mobile.system.games-grid.filters.sortBy.option.default'
    },
    {
        key: 2,
        value: 'a-z',
        label: 'playtech.mobile.system.games-grid.filters.sortBy.option.a-z'
    },
    {
        key: 3,
        value: 'z-a',
        label: 'playtech.mobile.system.games-grid.filters.sortBy.option.z-a'
    }
];

export const SORT_BY_OPTIONS_WITH_JACKPOTS = [
    ...SORT_BY_OPTIONS,
    {
        key: 4,
        value: 'jackpot',
        label: 'playtech.mobile.system.games-grid.filters.sortBy.option.jackpot'
    }
];
